// Reports view — "Daily macro breakdown" card body: the Target/Consumed/
// Adherence table plus the stacked chart, as in the legacy Classic view.
// Owns the 2 controls that view had: an Avg/Total toggle (table only — per-day
// average vs period sum, styled like the Classic one) and "Show Averages only"
// (chart only — swaps the daily bars for one bar per week, like Classic).
// Local state, same convention as the other Reports/Log controls.

import PropTypes from "prop-types";
import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import CheckboxInput from "../../../../../parts/checkbox-input";
import { buildMacroAdherenceTable } from "../../../../../utils/nutrition-progress";
import { ReportsMacroChart } from "./ReportsMacroChart";
import { ReportsMacroTable } from "./ReportsMacroTable";

const DATA_VIEWS = ["avg", "total"];

const ReportsMacroBreakdown = ({
  dayRows = [],
  series = [],
  weeklySeries = [],
}) => {
  const { t } = useTranslation("athlete-portal");
  const [dataView, setDataView] = useState("avg");
  const [showAveragesOnly, setShowAveragesOnly] = useState(false);

  const table = useMemo(
    () => buildMacroAdherenceTable(dayRows, dataView),
    [dayRows, dataView]
  );
  const chartSeries = showAveragesOnly ? weeklySeries : series;

  const handleShowAverages = useCallback(
    (e) => setShowAveragesOnly(e.target.checked),
    []
  );

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <CheckboxInput
          inputName="showAverageMacros"
          id="showAverageMacros"
          checked={showAveragesOnly}
          onChangeFn={handleShowAverages}
          labelText={t("nutritionPage.adherence.showAveragesOnly")}
        />
        {/* Same markup as the Classic view's NutritionAdherence.js toggle
            (global .unit-container + outline/secondary buttons). */}
        <div className="unit-container np-macro-breakdown__toggle">
          {DATA_VIEWS.map((view) => (
            <button
              key={view}
              type="button"
              className="h-7!"
              data-button-type={dataView === view ? "outline" : "secondary"}
              sz="small"
              onClick={() => setDataView(view)}
            >
              <span className="z-1">
                {t(`nutritionPage.adherence.${view}`)}
              </span>
            </button>
          ))}
        </div>
      </div>
      <ReportsMacroTable table={table} />
      <ReportsMacroChart series={chartSeries} />
    </>
  );
};

ReportsMacroBreakdown.propTypes = {
  dayRows: PropTypes.array,
  series: PropTypes.array,
  weeklySeries: PropTypes.array,
};

export default ReportsMacroBreakdown;
